import React from "react";
import styled from "styled-components";
import SiteBuilderTile from "./SiteBuilderTile";
import { useLocation } from "react-router-dom";

const FrameForSiteBuilder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // gap: 20px;
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
`;

const SiteBuilderText = styled.p`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Verizon-NHG-eDS";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: 0.5px;
`;

const VEstyle = styled.span`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Verizon-NHG-eDS";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-decoration-line: underline;
`;

const FrameForTiles = styled.div`
  display: flex;
  width: 100%;
  // background-color: #f6f6f6;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  height: auto;
`;

function SiteBuilder({ isEditable, clearFormSiteTagList, onValidationChange }) {
  const location = useLocation();
  const mode = location.state?.mode || "add";
  return (
    <>
      <FrameForSiteBuilder>
        {mode === "add" && (
          <SiteBuilderText>
            Based on your previous answers, we have generated this diagram of
            your site. Edit floor names to correspond to your site, then add
            areas representing locations where you have cameras placed on each
            floor. <VEstyle>View example</VEstyle>
          </SiteBuilderText>
        )}
        <FrameForTiles>
          <SiteBuilderTile
            isEditable={isEditable}
            clearFormSiteTagList={clearFormSiteTagList}
            onValidationChange={onValidationChange}
          />
        </FrameForTiles>
      </FrameForSiteBuilder>
    </>
  );
}

export default SiteBuilder;
